import { ReactNode } from 'react';

type MainContentProps = {
  children: ReactNode;
};

export function MainContent({ children }: MainContentProps) {
  return (
    <main className="flex flex-1 flex-col overflow-hidden bg-background">
      {children}
    </main>
  );
}

